export const localeCurrencyMap: { [key: string]: string } = {
  'en-US': 'USD',
  'en-GB': 'GBP',
  'en-CA': 'CAD',
  'en-AU': 'AUD',
  'fr-FR': 'EUR',
  'de-DE': 'EUR'
};
